let connected = false;
let device = null

export default {
    isInstalled() {
        return typeof navigator.usb !== "undefined";
    },
    async connect(id) {
        const devices = await navigator.usb.getDevices()
        device = devices.find(d => d.productId.toString() === id.toString())
        if (!device) {
            throw new Error("Impressora não encontrada")
        }
        await device.open()
        connected = true
        await device.selectConfiguration(1)
        await device.claimInterface(device.configuration.interfaces[0].interfaceNumber)
    },
    async disconnect() {
        if (!device) {
            return
        }
        await device.close()
        device = null
        connected = false
    },
    async list() {
        const devices = await navigator.usb.getDevices()
        return devices.map(device => {
            return {
                id: device.productId,
                name: device.productName
            }
        })
    },
    async findNewDevice() {
        const selectedDevice = await navigator.usb.requestDevice({filters: []})
        if (!selectedDevice) {
            return null
        }
        return {
            id: selectedDevice.productId,
            name: selectedDevice.productName
        }
    },
    isConnected() {
        return connected;
    },
    async write(data) {
        if (!connected || !device) {
            connected = false;
            throw new Error("Impressora desconectada")
        }
        data = new Uint8Array(data)
        // var encoder = new TextEncoder();
        // var data = encoder.encode(string);
        await device.transferOut(device.configuration.interfaces[0].alternate.endpoints[0].endpointNumber, data)
    }
};
